import React, { useEffect, useState, useContext, useRef } from "react";
import { Divider, List, Typography, TreeSelect, Button, Select, Card, Col, Form, Checkbox, Input, message, Radio, Row, Spin, DatePicker,Upload, Rate, Switch, Alert } from "antd";
import MapPicker from "./MapPicker";
import { PlusOutlined, MinusCircleOutlined , FrownOutlined, SafetyCertificateOutlined, MehOutlined, SmileOutlined, InboxOutlined, UploadOutlined } from '@ant-design/icons';
import { PageHeader } from '@ant-design/pro-layout'
import dayjs from 'dayjs';
import localObject from '../germanLocale.json';
import { API, API_BASE, STRAPI_API } from "../constant";
import { getToken } from "../helpers";
import { AuthContext } from "../context/AuthContext";
import { PicturesWall } from "./PicturesWall";
import styled, { createGlobalStyle } from 'styled-components';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import moment from 'moment';
import { useAuthContext } from "../context/AuthContext";

const { Option } = Select;
// Global style for antd
const GlobalStyle = createGlobalStyle`
  @import '~antd/dist/antd.css';
`;

const { RangePicker } = DatePicker;
const onChange = (value, dateString) => {
  console.log('Selected Time: ', value);
  console.log('Formatted Selected Time: ', dateString);
};
const onOk = (value) => {
  console.log('onOk: ', value);
};

//const dateFormat = 'YYYY-MM-DD HH:mm:ss';
const dateFormat = 'YYYY-MM-DDTHH:mm:ss.SSSZ';
const normFile = (e) => {
  console.log('Upload event:', e);
  if (Array.isArray(e)) {
    return e;
  }
  return (e || {}).fileList;
};

const VeranstaltungProfile = ({ type, id, veranstaltungenData, herstellerData, referentenData }) => {
const { setUser, user, availableSubs, sub } = useAuthContext();
  const selectedSubTitle = (sub ? ((availableSubs || []).find((availableSub) => (availableSub || {}).stripePlanId === ((sub || {}).plan || {}).id) || {}).title : false || "");


const veranstaltung = veranstaltungenData.find((veranstaltung) => veranstaltung.id == id) || {};

const [fileList, setFileList] = useState(((veranstaltung || {}).Medien || {}).data || []);
  const [loading, setLoading] = useState(false);
  const [selectedCoordinates, setSelectedCoordinates] = useState("");
  const [defaultValues, setDefaultValues] = useState({});
  const [form] = Form.useForm();
  const [placement, SetPlacement] = useState('');
  const [teilnehmerzahl, SetTeilnehmerzahl] = useState('');


    useEffect(() => {
        const currentValues = form.getFieldsValue();
        // Check if form values are empty
        const isFormEmpty = Object.values(currentValues).every(value => value === undefined || value === null || value === "");

        if (isFormEmpty) {
            form.setFieldsValue(defaultValues)
        }
    }, [form, defaultValues])

    useEffect(() => {
        const veranstaltung = veranstaltungenData.find((veranstaltung) => veranstaltung.id == id) || {};

        if (veranstaltung.Veranstaltungsort && veranstaltung.Veranstaltungsort.length === 2) setSelectedCoordinates(veranstaltung.Veranstaltungsort[0] + "," + veranstaltung.Veranstaltungsort[1]);

        const defaultValues = {};
        Object.keys(veranstaltung).forEach((key) => {
            defaultValues[key] = veranstaltung[key];
        })

        defaultValues.referents = ((veranstaltung.referents || {}).data || []).map((r) => { return { "label": (r.attributes.Vorname + " " + r.attributes.Name), "value": r.id }});
        defaultValues.herstellers = ((veranstaltung.herstellers || {}).data || []).map((r) => { return { "label": (r.attributes.Name), "value": r.id }});

        // Fix: Properly set up dates for form fields using dayjs
        if (veranstaltung.Startzeit && veranstaltung.Endzeit) {
            // Create dayjs objects for existing dates (Ant Design 5.0+ uses dayjs)
            const startDayjs = dayjs(veranstaltung.Startzeit);
            const endDayjs = dayjs(veranstaltung.Endzeit);

            if (startDayjs.isValid() && endDayjs.isValid()) {
                defaultValues.date = [startDayjs, endDayjs];
            }
        }

        setDefaultValues({
            ...defaultValues
        });

    }, [veranstaltungenData, id]);

  const handleSelectCoordinates = (coordinates) => {
    setSelectedCoordinates(coordinates);
  };

  const updateMarkerBasedOnStadt = () => {
      // get values of inputs Stadt and PLZ
      const stadt = form.getFieldValue("Stadt");
      const plz = form.getFieldValue("PLZ");

      fetch(`https://geocode.maps.co/search?q=${plz},${stadt},Germany&api_key=65d4b23015fec727948775azl6467b9`)
          .then((response) => response.json())
          .then((data) => {
          // update the marker based on the response
          if (((data || {})[0] || {}).lat) {
              setSelectedCoordinates(data[0].lat + "," + data[0].lon);
              message.success("Koordinaten gefunden und Karte angepasst!");
          } else {
              message.error("Keine Koordinaten gefunden...");
          }
          });

      }


  const handleVeranstaltungUpdate = async (data) => {
    setLoading(true);
    try {
      const veranstaltung = veranstaltungenData.find((veranstaltung) => veranstaltung.id == id);
      let response;

        console.debug("daddta user", user);

        const dataToPost = Object.fromEntries(
                               Object.entries(data).filter(([key, value]) => value !== undefined)
                             );

         if (!dataToPost["Bild"] || (veranstaltung && (dataToPost["Bild"] || {}).data)) delete dataToPost["Bild"];
        dataToPost.Medien = (fileList || []).map( media => {
                    if (((media.response) || []) [0]) {
                        return media.response[0];
                    } else {
                        return media;
                    }
                 });

         if ((((dataToPost.dragger || {})[0] || {}).response || {})[0]) dataToPost["Bild"]  = dataToPost.dragger[0].response[0];

dataToPost.herstellers = (dataToPost.herstellers || []).map(h => typeof h === 'number' ? h : h.value);
dataToPost.referents = (dataToPost.referents || []).map(h => typeof h === 'number' ? h : h.value);


         dataToPost.createdby = (user || {}).id;

         delete dataToPost.dragger;
//         delete dataToPost.Vergabestelle;
//          if (Object.keys(dataToPost.Vergabestelle).length === 0 || typeof ((dataToPost || {}).Vergabestelle || {}).Punkte == "undefined") delete dataToPost.Vergabestelle;

        // Convert dayjs objects to Date objects for API
        if ((dataToPost.date || [])[0]) dataToPost.Startzeit = dataToPost.date[0].toDate();
        if ((dataToPost.date || [])[1]) dataToPost.Endzeit = dataToPost.date[1].toDate();

        delete dataToPost.date;

        if (dataToPost.PLZ === "") delete dataToPost.PLZ;

        dataToPost.Veranstaltungsort = JSON.parse("[" + selectedCoordinates + "]");

      if (veranstaltung) {
        response = await fetch(`${API}/veranstaltungs/${veranstaltung.id}`, {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${getToken()}`,
            },
            body: JSON.stringify({data: dataToPost}),
          });
      } else {
        response = await fetch(`${API}/veranstaltungs`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${getToken()}`,
            },
            body: JSON.stringify({data: dataToPost}),
          });
      }
      const responseData = await response.json();

      if (responseData.error) {
        alert("Es konnte nicht gespeichert werden, bitte schicken Sie unserem Support die genauen Daten die gespeichert werden sollten um das Problem zu lösen oder verändern Sie die Eingabe oder verändern Sie die Eingabe.");
      } else {
        // Update logic based on your application's requirements
        message.success("Daten erfolgreich gespeichert!");
        window.location.replace("/admin/meine-inserate");
      }
    } catch (error) {
      console.error(error);
      message.error("Es ist etwas schief gelaufen...");
    } finally {
      setLoading(false);
    }
  };

  console.debug("selectedCoordinates", selectedCoordinates );


  const placementChange = (e) => {
    SetPlacement(e.target.value);
  };

  const teilnehmerzahlChange = (e) => {
    SetTeilnehmerzahl(e.target.value);
  };

    const fields = [
         { key: '0', name: ['Fortbildungspunkte', 0], fieldKey: '0' },
         { key: '1', name: ['Fortbildungspunkte', 1], fieldKey: '1' },
         { key: '2', name: ['Fortbildungspunkte', 2], fieldKey: '2' },
       ];

    const isNotAllowed = (typeof veranstaltung.id === 'undefined') && (selectedSubTitle === "Veranstalter: Classic" && veranstaltungenData.filter((f,i) => f.createdby === (user || {}).id).length > 2);
    console.debug("ttt",veranstaltung, (defaultValues || {}).Startzeit, (defaultValues || {}).Endzeit, [dayjs((defaultValues || {}).Startzeit, dateFormat), dayjs((defaultValues || {}).Endzeit, dateFormat)]);

  return (
    <>
    { !isNotAllowed ? <>
      <Card className="veranstaltung_profile_card">
      <PageHeader style={{display: 'none'}}
      backIcon={<SafetyCertificateOutlined style={{ color: "#fff", fontSize: 32 }} />}
          className="veranstaltung-zertifizierung-header"
          onBack={() => null}
          title={<span style={{ color: "#fff" }}> Veranstaltung zertifizieren</span>}
          subTitle={<span style={{ color: "#fff" }}> Falls Sie Ihre Veranstaltung zertifizieren möchten, können Sie den Antrag hier stellen...</span>}
        />
          <Form
            form={form}
            layout="vertical"
            initialValues={defaultValues}
            onFinish={handleVeranstaltungUpdate}
          >
            <Row gutter={[16, 16]}>
              <Col span={8}>
              <Form.Item
                label="Name der Veranstaltung"
                name="Veranstaltungsname"
                rules={[
                  {
                    required: false,
                    message: "Label ist ein Pflichtfeld!",
                    type: "string",
                  },
                ]}
              >
                <Input placeholder="Name" />
              </Form.Item>
            </Col>
            <Col span={8}>
                          <Form.Item
                            label="Name des Veranstalters"
                            name="Veranstaltername"
                            rules={[
                              {
                                required: false,
                                message: "Label ist ein Pflichtfeld!",
                                type: "string",
                              },
                            ]}
                          >
                            <Input placeholder="Name" />
                          </Form.Item>
                        </Col>
                <Col span={6}>
                    <Form.Item
                        label="Datum"
                        name="date"
                    >
                        <RangePicker
                            locale={localObject}
                            showTime={{
                                format: 'HH:mm',
                            }}
                            format="YYYY-MM-DD HH:mm"
                            onChange={onChange}
                            onOk={onOk}
                        />
                    </Form.Item>
                </Col>
                    {(((veranstaltung.Bild || {}).data || {}).attributes) && <Col span={12}><img className={"leafImage leafImage--veranstaltung"} src={API_BASE + veranstaltung.Bild.data.attributes.url}  /> </Col> }
                    <Col span={(((veranstaltung.Bild || {}).data || {}).attributes) ? 8 : 24}>
                       <Form.Item label="Bild hochladen" name="Bild">
                            <Form.Item name="dragger" valuePropName="fileList" getValueFromEvent={normFile} noStyle>
                              <Upload.Dragger name="files"
                              crossOrigin={"use-credentials"}
                              data={{
                                ref: "api::veranstaltung.veranstaltung",
//                                refId: "42142444",
                                field: "Bild",
                              }} action={`${API}/upload`} headers={{ "Authorization": `Bearer ${getToken()}`}}>
                                <p className="ant-upload-drag-icon">
                                  <InboxOutlined />
                                </p>
                                <p className="ant-upload-text">Klicken Sie hier oder ziehen Sie das Bild oder Video in diesen Bereich</p>
                                <p className="ant-upload-hint">Bilder im Format .png, .jpeg, .jpg werden unterstützt</p>
                              </Upload.Dragger>
                            </Form.Item>
                          </Form.Item>
                      </Col>

                      <Divider />
                      { selectedSubTitle === "Veranstalter: Premium" && <Form.Item label="Medien" name="Medien (Erlaubt sind sowohl PDF, als auch Bild-, Video- und Audioformate)">
                          <PicturesWall fileList={fileList} setFileList={setFileList} />
                        </Form.Item> }
                      <Col span={24}>
                                      <Form.Item
                                        label="Beschreibung"
                                        name="Beschreibung"
                                        rules={[
                                          {
                                            required: false,
                                            message: "Beschreibung ist ein Pflichtfeld!",
                                            type: "string",
                                          },
                                        ]}
                                      >
                                        <ReactQuill theme="snow" />
                                      </Form.Item>
                    </Col>
                     <Col span={24}>
                                              <Form.Item
                                                value={teilnehmerzahl}
                                                label="Erwartete Teilnehmerzahl"
                                                name="ErwarteteTeilnehmerzahl"
                                                rules={[
                                                ]}
                                              >
                                                <Radio.Group value={teilnehmerzahl} onChange={teilnehmerzahlChange}>
                                                        <Radio.Button value="z0-20">0-20</Radio.Button>
                                                        <Radio.Button value="z21-50">21-50</Radio.Button>
                                                        <Radio.Button value="z51-100">51-100</Radio.Button>
                                                        <Radio.Button value="z101-150">101-150</Radio.Button>
                                                        <Radio.Button value="z151-300">151-300</Radio.Button>
                                                        <Radio.Button value="z301-500">301-500</Radio.Button>
                                                        <Radio.Button value="züber 150">über 500</Radio.Button>
                                                      </Radio.Group>
                                              </Form.Item>
                                            </Col>
                      <Col span={9}>
                        <Form.Item label="Anbieter">
                          <Input.Group compact>
                            <Form.Item
                              name={'Anbieternummer'}
                              noStyle
                            >
                              <Input style={{ width: '50%', height: '34px' }} placeholder="Anbieternummer" />
                            </Form.Item>
                          </Input.Group>
                        </Form.Item>
                      </Col>
                      <Col span={5}>
                          <Form.Item
                            label="Ansprechpartner"
                            name="Ansprechpartner"
                            rules={[
                              {
                                required: false,
                                message: "Ansprechpartner ist ein Pflichtfeld!",
                                type: "string",
                              },
                            ]}
                          >
                            <Input type="string" placeholder="Ansprechpartner " />
                          </Form.Item>
                        </Col>
                      <Col span={8}>
                        <Form.Item
                          value={placement}
                          label="Teilnehmergebühr"
                          name="Teilnehmergebuehr"
                          rules={[
                          ]}
                        >
                          <Radio.Group value={placement} onChange={placementChange}>
                                  <Radio.Button value="z0-50">0-50 €</Radio.Button>
                                  <Radio.Button value="z51-100">51-100 €</Radio.Button>
                                  <Radio.Button value="z101-150">101-150 €</Radio.Button>
                                  <Radio.Button value="züber 150">über 150€</Radio.Button>
                                </Radio.Group>
                        </Form.Item>
                      </Col>

                      <Col span={24}>
<Form.List
  style={{ display: "block" }}
  className={"formList"}
  label="Fortbildungspunkte"
  name="Fortbildungspunkte"
  rules={[]}
  fieldKey="Fortbildungspunkte"
>
  {(fields, { add, remove }) => (
    <div className="flexHack">
      {fields.map((field, index) => (
        <List.Item key={field.key}>
          <Row style={{ flex: '0 0 100%;' }} gutter={[24, 24]}>
            <Col span={8}>
              <Form.Item
                name={[field.name, 'Vergabestelle']}
                style={{ width: '100%' }}
              >
                  <Select style={{ paddingRight: '2em' }} placeholder="Vergabestelle auswählen">
                      <Option value="Initiative Chronische Wunde e.V. (ICW)">ICW e.V.</Option>
                      <Option value="Deutsche Gesellschaft für Wundheilung und Wundbehandlung e.V. (DGfW)">DGfW e.V.</Option>
                      <Option value="Akademie ZWM GmbH (ZWM)">Akademie ZWM GmbH (ZWM)</Option>
                      <Option value="Registrierung beruflich Pflegender GmbH (regbp)">Registrierung beruflich Pflegender GmbH (regbp)</Option>
                      <Option value="Ärztekammer">Ärztekammer</Option>
                      <Option value="Fachgesellschaft Stoma-Kontinenz-Wunde e.V. (FgSKW)">Fachgesellschaft Stoma-Kontinenz-Wunde e.V. (FgSKW)</Option>
                      <Option value="Verband Deutscher Podologen e.V. (VDP)">Verband Deutscher Podologen e.V. (VDP)</Option>
                      <Option value="Deutscher Verband für Podologie e.V. (ZFD)">Deutscher Verband für Podologie e.V. (ZFD)</Option>
                      <Option value="Verband der Diabetes-Beratungs- und Schulungsberufe in Deutschland (VDBD)">Verband der Diabetes-Beratungs- und Schulungsberufe in Deutschland (VDBD)</Option>
                    </Select>

                  </Form.Item>
            </Col>
            <Col span={10}>
              <Form.Item
                name={[field.name, 'Punkte']}
                style={{ width: '100%' }}
              >
                  <Rate
                    count={10}
                    style={{ color: '#3545b3' }}
                    defaultValue={0}
                    character={({ index }) => index + 1}
                    name={[field.name, 'Punkte']}
                  />
              </Form.Item>
            </Col>
            <Col span={4}>
                <MinusCircleOutlined onClick={() => remove(field.name)} />
            </Col>
          </Row>
        </List.Item>
      ))}
      <Form.Item>
        <Button
          type="dashed"
          onClick={() => add()}
          style={{ width: '100%' }}
          icon={<PlusOutlined />}
        >
          Fortbildungspunkte hinzufügen
        </Button>
      </Form.Item>
    </div>
  )}
</Form.List>
                      </Col>


              <Col span={14}>
                <Form.Item
                  label="Stadt"
                  name="Stadt"
                  rules={[
                    {
                      required: false,
                      message: "Stadt ist ein Pflichtfeld!",
                      type: "string",
                    },
                  ]}
                >
                  <Input placeholder="Stadt" />
                </Form.Item>
              </Col>
              <Col span={9}>
                <Form.Item
                  label="PLZ"
                  name="PLZ"
                  rules={[
                  ]}
                >
                  <Input placeholder="PLZ" />
                </Form.Item>
              </Col>
<div style={{backgroundColor: "rgb(53 95 179 / 10%)" ,width: "100%", display: "flex", paddingTop: "1em"}} >
              <Col span={9}>
              <Form.Item
                              label={<span  style={{}}>Dies ist eine Online Veranstaltung</span>}
                              name="isonlineveranstaltung"
                              valuePropName="checked"
                            >
                              <Switch />
                            </Form.Item>

              </Col>
              <Col span={14}>
              <Form.Item
                label="Link zur Online Veranstaltung"
                name="ExternerLinkOnlineVeranstaltung"
              >
                <Input placeholder="beispiel.de"  addonBefore="https://" />
              </Form.Item>
              </Col></div>
            <Col span={24}>
               <Alert
                  message="Nachdem Sie obige Adresse angegeben haben (Oder von ICW übertragen haben), klicken Sie auf untenstehenden Button um den Marker zuzuweisen, danach kann der Marker auf den genauen Veranstaltungsort gezogen werden..."
                  type="info"
                  showIcon
                  style={{
                    marginBottom: 16,
                    backgroundColor: '#ffebee',
                    borderColor: '#f44336',
                    color: '#d32f2f'
                  }}
                />
              <Button ghost
                type="primary"
                size="large"
                onClick={updateMarkerBasedOnStadt}
              >
                Aktualisiere den Marker basierend auf der Stadt und Postleitzahl
              </Button>
          </Col>

              <Col span={24}>
              <div className={"ant-form-item"}>
              <div className={"ant-row ant-form-item-row"}>
                    <MapPicker defaultMarkerCoordinates={selectedCoordinates ? JSON.parse("[" + selectedCoordinates + "]") : [
                     50.02254683363231,
                     10.919726205325217
                     ]} onSelectCoordinates={handleSelectCoordinates} />
                     </div>
                 </div>
              </Col>
              <Col span={20}>
                   { true && <Col span={22}>
                                <Form.Item
                                  label="Fortbildungsinhalte Wundexperte ICW ®"
                                  name="FortbildungsinhalteWundexperteICW"
                                  rules={[
                                  ]}
                                >
                                <Select
                                      mode="multiple"
                                      allowClear
                                      style={{
                                        width: '100%',
                                      }}
                                      placeholder="Fortbildungsinhalte Wundexperte ICW ®"
                                      options={[
                                                 { "label": "ICW und Kurskonzept (Wundexperte ICW ®)", "value": "ICW und Kurskonzept (Wundexperte ICW ®)" },
                                                 { "label": "Haut/Hautpflege (Wundexperte ICW ®)", "value": "Haut/Hautpflege (Wundexperte ICW ®)" },
                                                 { "label": "Wundarten und Wundheilung (Wundexperte ICW ®)", "value": "Wundarten und Wundheilung (Wundexperte ICW ®)" },
                                                 { "label": "Schmerz (Wundexperte ICW ®)", "value": "Schmerz (Wundexperte ICW ®)" },
                                                 { "label": "Hospitation und Leistungsnachweise (Wundexperte ICW ®)", "value": "Hospitation und Leistungsnachweise (Wundexperte ICW ®)" },
                                                 { "label": "Hygiene in der Wundversorgung (Wundexperte ICW ®)", "value": "Hygiene in der Wundversorgung (Wundexperte ICW ®)" },
                                                 { "label": "Wundbeurteilung und Wunddokumentation (Wundexperte ICW ®)", "value": "Wundbeurteilung und Wunddokumentation (Wundexperte ICW ®)" },
                                                 { "label": "Expertenstandard Pflege von Menschen mit Chronischen Wunden (DNQP) (Wundexperte ICW ®)", "value": "Expertenstandard Pflege von Menschen mit Chronischen Wunden (DNQP) (Wundexperte ICW ®)" },
                                                 { "label": "Ulcus cruris Prophylaxe/Behandlung (Wundexperte ICW ®)", "value": "Ulcus cruris Prophylaxe/Behandlung (Wundexperte ICW ®)" },
                                                 { "label": "Dekubitus/Prophylaxe und Therapie (Wundexperte ICW ®)", "value": "Dekubitus/Prophylaxe und Therapie (Wundexperte ICW ®)" },
                                                 { "label": "Diabetisches Fußsyndrom (DFS)/Prophylaxe und Therapie (Wundexperte ICW ®)", "value": "Diabetisches Fußsyndrom (DFS)/Prophylaxe und Therapie (Wundexperte ICW ®)" },
                                                 { "label": "Grundsätze Wundversorgung und Wundauflagen (Wundexperte ICW ®)", "value": "Grundsätze Wundversorgung und Wundauflagen (Wundexperte ICW ®)" },
                                                 { "label": "Wundreinigung/Wundspülung (Wundexperte ICW ®)", "value": "Wundreinigung/Wundspülung (Wundexperte ICW ®)" },
                                                 { "label": "Infektmanagement (Wundexperte ICW ®)", "value": "Infektmanagement (Wundexperte ICW ®)" },
                                                 { "label": "Fallmanagement (Wundexperte ICW ®)", "value": "Fallmanagement (Wundexperte ICW ®)" },
                                                 { "label": "Finanzierung (Wundexperte ICW ®)", "value": "Finanzierung (Wundexperte ICW ®)" },
                                                 { "label": "Rechtliche Aspekte der Wundversorgung Edukation (Wundexperte ICW ®)", "value": "Rechtliche Aspekte der Wundversorgung Edukation (Wundexperte ICW ®)" },
                                                 { "label": "Ernährung (Wundexperte ICW ®)", "value": "Ernährung (Wundexperte ICW ®)" },
                                                 { "label": "Vertiefungsstunde (Wundexperte ICW ®)", "value": "Vertiefungsstunde (Wundexperte ICW ®)" }
                                               ]
                  }
                                    />
                                </Form.Item>
                              </Col>}


                              { true && <Col span={22}>
                                <Form.Item
                                  label="Fortbildungsinhalte Fachtherapeut Wunde ICW ®"
                                  name="FortbildungsinhalteFachtherapeutWundeICW"
                                  rules={[
                                  ]}
                                >
                      <TreeSelect
                        showSearch
                        style={{ width: '100%' }}
                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                        placeholder="Fortbildungsinhalte Fachtherapeut Wunde ICW ®"
                        allowClear
                        multiple
                        treeDefaultExpandAll
                        onChange={onChange}
                        treeData={[
                                    {
                                      "value": "KURSEINFÜHRUNG (Fachtherapeut Wunde ICW ®)",
                                      "title": "KURSEINFÜHRUNG (Fachtherapeut Wunde ICW ®)",
                                      "children": []
                                    },
                                    {
                                      "value": "CHRONISCHE WUNDEN PATHOPHYSIOLOGIE UND Diagnostik (Fachtherapeut Wunde ICW ®)",
                                      "title": "CHRONISCHE WUNDEN PATHOPHYSIOLOGIE UND Diagnostik (Fachtherapeut Wunde ICW ®)",
                                      "children": []
                                    },
                                    {
                                      "value": "WUNDASSESSMENT UND WUNDDOKUMENTATION (Fachtherapeut Wunde ICW ®)",
                                      "title": "WUNDASSESSMENT UND WUNDDOKUMENTATION (Fachtherapeut Wunde ICW ®)",
                                      "children": []
                                    },
                                    {
                                      "value": "LYMPHATISCHE ERKRANKUNGEN (Fachtherapeut Wunde ICW ®)",
                                      "title": "LYMPHATISCHE ERKRANKUNGEN (Fachtherapeut Wunde ICW ®)",
                                      "children": []
                                    },
                                    {
                                      "value": "KOMPLEXE WUNDSITUATIONEN/WUNDREINIGUNG/HAUTSCHÄDEN (Fachtherapeut Wunde ICW ®)",
                                      "title": "KOMPLEXE WUNDSITUATIONEN/WUNDREINIGUNG/HAUTSCHÄDEN (Fachtherapeut Wunde ICW ®)",
                                      "children": []
                                    },
                                    {
                                      "value": "TUMORWUNDEN/ PALLIATIVE VERSORGUNG (Fachtherapeut Wunde ICW ®)",
                                      "title": "TUMORWUNDEN/ PALLIATIVE VERSORGUNG (Fachtherapeut Wunde ICW ®)",
                                      "children": []
                                    },
                                    {
                                      "value": "SCHMERZ (Fachtherapeut Wunde ICW ®)",
                                      "title": "SCHMERZ (Fachtherapeut Wunde ICW ®)",
                                      "children": []
                                    },
                                    {
                                      "value": "GESUNDHEITSÖKONOMIE (Fachtherapeut Wunde ICW ®)",
                                      "title": "GESUNDHEITSÖKONOMIE (Fachtherapeut Wunde ICW ®)",
                                      "children": []
                                    },
                                    {
                                      "value": "HYGIENE (Fachtherapeut Wunde ICW ®)",
                                      "title": "HYGIENE (Fachtherapeut Wunde ICW ®)",
                                      "children": []
                                    },
                                    {
                                      "value": "ULCUS CRURIS (Fachtherapeut Wunde ICW ®)",
                                      "title": "ULCUS CRURIS (Fachtherapeut Wunde ICW ®)",
                                      "children": []
                                    },
                                    {
                                      "value": "Grundlagen Gefäßsystem, CVI und Differentialdiagnosen",
                                      "title": "Grundlagen Gefäßsystem, CVI und Differentialdiagnosen",
                                      "children": [
                                        {
                                          "value": "a) Interventionen bei venösem Ulcus und Lokaltherapie",
                                          "title": "a) Interventionen bei venösem Ulcus und Lokaltherapie",
                                          "children": []
                                        },
                                        {
                                          "value": "b) Ulcus cruris arteriosum/mixtum",
                                          "title": "b) Ulcus cruris arteriosum/mixtum",
                                          "children": []
                                        },
                                        {
                                          "value": "c) Amputation",
                                          "title": "c) Amputation",
                                          "children": []
                                        },
                                        {
                                          "value": "d) Kompression und Kommunikation",
                                          "title": "d) Kompression und Kommunikation",
                                          "children": []
                                        }
                                      ]
                                    },
                                    {
                                      "value": "DEKUBITUS (Fachtherapeut Wunde ICW ®)",
                                      "title": "DEKUBITUS (Fachtherapeut Wunde ICW ®)",
                                      "children": [
                                        {
                                          "value": "a) Grundlagen und Differentialdiagnostik",
                                          "title": "a) Grundlagen und Differentialdiagnostik",
                                          "children": []
                                        },
                                        {
                                          "value": "b) Hilfsmittel und Kommunikation",
                                          "title": "b) Hilfsmittel und Kommunikation",
                                          "children": []
                                        },
                                        {
                                          "value": "c) Therapie und Schwerpunkte Lokaltherapie",
                                          "title": "c) Therapie und Schwerpunkte Lokaltherapie",
                                          "children": []
                                        }
                                      ]
                                    },
                                    {
                                      "value": "DIABETISCHES FUßSYNDROM (Fachtherapeut Wunde ICW ®)",
                                      "title": "DIABETISCHES FUßSYNDROM (Fachtherapeut Wunde ICW ®)",
                                      "children": [
                                        {
                                          "value": "a) Grundlagen und Diagnostik",
                                          "title": "a) Grundlagen und Diagnostik",
                                          "children": []
                                        },
                                        {
                                          "value": "b) Unterstützende Maßnahmen und Kommunikation",
                                          "title": "b) Unterstützende Maßnahmen und Kommunikation",
                                          "children": []
                                        },
                                        {
                                          "value": "c) Infektionsmanagement und lokale Wundtherapie",
                                          "title": "c) Infektionsmanagement und lokale Wundtherapie",
                                          "children": []
                                        }
                                      ]
                                    },
                                    {
                                      "value": "THERMISCH BEDINGTE WUNDEN/ NARBEN (Fachtherapeut Wunde ICW ®)",
                                      "title": "THERMISCH BEDINGTE WUNDEN/ NARBEN (Fachtherapeut Wunde ICW ®)",
                                      "children": [
                                        {
                                          "value": "a) Thermisch bedingte Wunden",
                                          "title": "a) Thermisch bedingte Wunden",
                                          "children": []
                                        },
                                        {
                                          "value": "b) Narben",
                                          "title": "b) Narben",
                                          "children": []
                                        }
                                      ]
                                    },
                                    {
                                      "value": "DERMATOLOGISCHE WUNDEN (Fachtherapeut Wunde ICW ®)",
                                      "title": "DERMATOLOGISCHE WUNDEN (Fachtherapeut Wunde ICW ®)",
                                      "children": []
                                    },
                                    {
                                      "value": "PRÜFUNGSVORBEREITUNG (Fachtherapeut Wunde ICW ®)",
                                      "title": "PRÜFUNGSVORBEREITUNG (Fachtherapeut Wunde ICW ®)",
                                      "children": []
                                    },
                                    {
                                      "value": "ORGANISATION WUNDMANAGEMENT (Fachtherapeut Wunde ICW ®)",
                                      "title": "ORGANISATION WUNDMANAGEMENT (Fachtherapeut Wunde ICW ®)",
                                      "children": []
                                    },
                                    {
                                      "value": "LEISTUNGSNACHWEISE (Fachtherapeut Wunde ICW ®)",
                                      "title": "LEISTUNGSNACHWEISE (Fachtherapeut Wunde ICW ®)",
                                      "children": []
                                    }
                                  ]
                  }
                      />
                                </Form.Item>
                              </Col> }

                              { true && <Col span={22}>
                                            <Form.Item
                                              label="Fortbildungsinhalte Ärztlicher Wundexperte ICW ®"
                                              name="FortbildungsinhalteAerztlicherWundexperteICW"
                                              rules={[
                                              ]}
                                            >
                                            <Select
                                                  mode="multiple"
                                                  allowClear
                                                  style={{
                                                    width: '100%',
                                                  }}
                                                  placeholder="Fortbildungsinhalte Ärztlicher Wundexperte ICW ®"
                                                  options={
                                                  [
                                                    {
                                                      "label": "ICW UND KURSKONZEPT SOWIE EINFÜHRUNG UND KENNENLERNEN (Ärztlicher Wundexperte ICW ®)",
                                                      "value": "ICW UND KURSKONZEPT SOWIE EINFÜHRUNG UND KENNENLERNEN (Ärztlicher Wundexperte ICW ®)"
                                                    },
                                                    {
                                                      "label": "PHYSIOLOGIE UND PATHOPHYSIOLOGIE DER WUNDHEILUNG (Ärztlicher Wundexperte ICW ®)",
                                                      "value": "PHYSIOLOGIE UND PATHOPHYSIOLOGIE DER WUNDHEILUNG (Ärztlicher Wundexperte ICW ®)"
                                                    },
                                                    {
                                                      "label": "WUNDBEURTEILUNG UND -DOKUMENTATION (Ärztlicher Wundexperte ICW ®)",
                                                      "value": "WUNDBEURTEILUNG UND -DOKUMENTATION (Ärztlicher Wundexperte ICW ®)"
                                                    },
                                                    {
                                                      "label": "WUNDTHERAPEUTIKA – Systematik (Ärztlicher Wundexperte ICW ®)",
                                                      "value": "WUNDTHERAPEUTIKA – Systematik (Ärztlicher Wundexperte ICW ®)"
                                                    },
                                                    {
                                                      "label": "LOKALTHERAPIE CHRONISCHER WUNDEN - SYSTEMATIK (Ärztlicher Wundexperte ICW ®)",
                                                      "value": "LOKALTHERAPIE CHRONISCHER WUNDEN - SYSTEMATIK (Ärztlicher Wundexperte ICW ®)"
                                                    },
                                                    {
                                                      "label": "EXSUDAT- UND GERUCHSMANAGEMENT SOWIE WUNDRANDSCHUTZ (Ärztlicher Wundexperte ICW ®)",
                                                      "value": "EXSUDAT- UND GERUCHSMANAGEMENT SOWIE WUNDRANDSCHUTZ (Ärztlicher Wundexperte ICW ®)"
                                                    },
                                                    {
                                                      "label": "DÉBRIDEMENT – SYSTEMATIK (Ärztlicher Wundexperte ICW ®)",
                                                      "value": "DÉBRIDEMENT – SYSTEMATIK (Ärztlicher Wundexperte ICW ®)"
                                                    },
                                                    {
                                                      "label": "PHYSIKALISCHE VERFAHREN IN DER WUNDBEHANDLUNG - SYSTEMATIK (Ärztlicher Wundexperte ICW ®)",
                                                      "value": "PHYSIKALISCHE VERFAHREN IN DER WUNDBEHANDLUNG - SYSTEMATIK (Ärztlicher Wundexperte ICW ®)"
                                                    },
                                                    {
                                                      "label": "SPEZIELLE WUNDTHERAPEUTIKA (Ärztlicher Wundexperte ICW ®)",
                                                      "value": "SPEZIELLE WUNDTHERAPEUTIKA (Ärztlicher Wundexperte ICW ®)"
                                                    },
                                                    {
                                                      "label": "EXTERNA INKLUSIVE HAUTPFLEGE (Ärztlicher Wundexperte ICW ®)",
                                                      "value": "EXTERNA INKLUSIVE HAUTPFLEGE (Ärztlicher Wundexperte ICW ®)"
                                                    },
                                                    {
                                                      "label": "PAVK KRANKHEITSBILD UND DIAGNOSTIK ® ABI-MESSUNG (Ärztlicher Wundexperte ICW ®)",
                                                      "value": "PAVK KRANKHEITSBILD UND DIAGNOSTIK ® ABI-MESSUNG (Ärztlicher Wundexperte ICW ®)"
                                                    },
                                                    {
                                                      "label": "PAVK THERAPIE (Ärztlicher Wundexperte ICW ®)",
                                                      "value": "PAVK THERAPIE (Ärztlicher Wundexperte ICW ®)"
                                                    },
                                                    {
                                                      "label": "CVI KRANKHEITSBILD UND DIAGNOSTIK (Ärztlicher Wundexperte ICW ®)",
                                                      "value": "CVI KRANKHEITSBILD UND DIAGNOSTIK (Ärztlicher Wundexperte ICW ®)"
                                                    },
                                                    {
                                                      "label": "CVI THERAPIE (Ärztlicher Wundexperte ICW ®)",
                                                      "value": "CVI THERAPIE (Ärztlicher Wundexperte ICW ®)"
                                                    },
                                                    {
                                                      "label": "KOMPRESSION - SYSTEMATIK UND (Ärztlicher Wundexperte ICW ®)",
                                                      "value": "KOMPRESSION - SYSTEMATIK UND (Ärztlicher Wundexperte ICW ®)"
                                                    },
                                                    {
                                                      "label": "ÖDEME UND DEREN DIFFERENZIALDIAGNOSE (Ärztlicher Wundexperte ICW ®)",
                                                      "value": "ÖDEME UND DEREN DIFFERENZIALDIAGNOSE (Ärztlicher Wundexperte ICW ®)"
                                                    },
                                                    {
                                                      "label": "LYMPHÖDEM PRIMÄR UND SEKUNDÄR - DIAGNOSTIK UND THERAPIEANSÄTZE (Ärztlicher Wundexperte ICW ®)",
                                                      "value": "LYMPHÖDEM PRIMÄR UND SEKUNDÄR - DIAGNOSTIK UND THERAPIEANSÄTZE (Ärztlicher Wundexperte ICW ®)"
                                                    },
                                                    {
                                                      "label": "HYGIENE BEI CHRONISCHEN WUNDEN (Ärztlicher Wundexperte ICW ®)",
                                                      "value": "HYGIENE BEI CHRONISCHEN WUNDEN (Ärztlicher Wundexperte ICW ®)"
                                                    },
                                                    {
                                                      "label": "INFEKTIONSBEKÄMPFUNG – (Ärztlicher Wundexperte ICW ®)",
                                                      "value": "INFEKTIONSBEKÄMPFUNG – (Ärztlicher Wundexperte ICW ®)"
                                                    },
                                                    {
                                                      "label": "DIABETISCHES FUßSYNDROM GRUNDLAGEN UND DIAGNOSTIK (Ärztlicher Wundexperte ICW ®)",
                                                      "value": "DIABETISCHES FUßSYNDROM GRUNDLAGEN UND DIAGNOSTIK (Ärztlicher Wundexperte ICW ®)"
                                                    },
                                                    {
                                                      "label": "DIABETISCHES FUßSYNDROM - THERAPIE INKLUSIVE ENTLASTUNGSVERFAHREN (Ärztlicher Wundexperte ICW ®)",
                                                      "value": "DIABETISCHES FUßSYNDROM - THERAPIE INKLUSIVE ENTLASTUNGSVERFAHREN (Ärztlicher Wundexperte ICW ®)"
                                                    },
                                                    {
                                                      "label": "ÜBERLEITUNGSMANAGEMENT UND INTERPROFESSIONELLES NETZWERK HEIL- UND HILFSMITTEL BEI PATIENTEN MIT CHRONISCHEN WUNDEN (Ärztlicher Wundexperte ICW ®)",
                                                      "value": "ÜBERLEITUNGSMANAGEMENT UND INTERPROFESSIONELLES NETZWERK HEIL- UND HILFSMITTEL BEI PATIENTEN MIT CHRONISCHEN WUNDEN (Ärztlicher Wundexperte ICW ®)"
                                                    },
                                                    {
                                                      "label": "ÜBUNGSSEQUENZ FALLMANAGEMENT (Ärztlicher Wundexperte ICW ®)",
                                                      "value": "ÜBUNGSSEQUENZ FALLMANAGEMENT (Ärztlicher Wundexperte ICW ®)"
                                                    },
                                                    {
                                      "label": "DEKUBITUS (Ärztlicher Wundexperte ICW ®)",
                                                      "value": "DEKUBITUS (Ärztlicher Wundexperte ICW ®)"
                                                    },
                                                    {
                                                      "label": "PLASTISCH-CHIRURGISCHE THERAPIEOPTIONEN (Ärztlicher Wundexperte ICW ®)",
                                                      "value": "PLASTISCH-CHIRURGISCHE THERAPIEOPTIONEN (Ärztlicher Wundexperte ICW ®)"
                                                    },
                                                    {
                                                      "label": "PALLIATIVE WUNDBEHANDLUNG (Ärztlicher Wundexperte ICW ®)",
                                                      "value": "PALLIATIVE WUNDBEHANDLUNG (Ärztlicher Wundexperte ICW ®)"
                                                    },
                                                    {
                                                      "label": "SCHMERZTHERAPIE (Ärztlicher Wundexperte ICW ®)",
                                                      "value": "SCHMERZTHERAPIE (Ärztlicher Wundexperte ICW ®)"
                                                    },
                                                    {
                                                      "label": "GESUNDHEITSÖKONOMIE (Ärztlicher Wundexperte ICW ®)",
                                                      "value": "GESUNDHEITSÖKONOMIE (Ärztlicher Wundexperte ICW ®)"
                                                    },
                                                    {
                                                      "label": "MEDIZINPRODUKTERECHT (Ärztlicher Wundexperte ICW ®)",
                                                      "value": "MEDIZINPRODUKTERECHT (Ärztlicher Wundexperte ICW ®)"
                                                    },
                                                    {
                                                      "label": "ERNÄHRUNG BEI PATIENTEN MIT CHRONISCHEN WUNDEN (Ärztlicher Wundexperte ICW ®)",
                                                      "value": "ERNÄHRUNG BEI PATIENTEN MIT CHRONISCHEN WUNDEN (Ärztlicher Wundexperte ICW ®)"
                                                    },
                                                    {
                                                      "label": "SELTENE URSACHEN CHRONISCHER WUNDEN (Ärztlicher Wundexperte ICW ®)",
                                                      "value": "SELTENE URSACHEN CHRONISCHER WUNDEN (Ärztlicher Wundexperte ICW ®)"
                                                    },
                                                    {
                                                      "label": "THERMISCHE URSACHEN FÜR WUNDEN (Ärztlicher Wundexperte ICW ®)",
                                                      "value": "THERMISCHE URSACHEN FÜR WUNDEN (Ärztlicher Wundexperte ICW ®)"
                                                    },
                                                    {
                                                      "label": "ÜBUNGSSEQUENZ FALLMANAGEMENT (Ärztlicher Wundexperte ICW ®)",
                                                      "value": "ÜBUNGSSEQUENZ FALLMANAGEMENT (Ärztlicher Wundexperte ICW ®)"
                                                    },
                                                    {
                                                      "label": "PRÜFUNGSVORBEREITUNG (Ärztlicher Wundexperte ICW ®)",
                                                      "value": "PRÜFUNGSVORBEREITUNG (Ärztlicher Wundexperte ICW ®)"
                                                    }
                                                  ]

                              }
                                                />
                                            </Form.Item>
                                          </Col> }

                                          { true && <Col span={22}>
                                                        <Form.Item
                                                          label="Fortbildungsinhalte Pflegetherapeut Wunde ICW ®"
                                                          name="FortbildungsinhaltePflegetherapeutWundeICW"
                                                          rules={[
                                                          ]}
                                                        >
                                                        <Select
                                                              mode="multiple"
                                                              allowClear
                                                              style={{
                                                                width: '100%',
                                                              }}
                                                              placeholder="Fortbildungsinhalte Pflegetherapeut Wunde ICW ®"
                                                              options={[
                                                                         {
                                                                           "label": "SEMINAREINFÜHRUNG (Pflegetherapeut Wunde ICW ®)",
                                                                           "value": "SEMINAREINFÜHRUNG (Pflegetherapeut Wunde ICW ®)"
                                                                         },
                                                                         {
                                                                           "label": "WISSENSCHAFTLICH ORIENTIERTES ARBEITEN (THEMENBLOCK 1) (Pflegetherapeut Wunde ICW ®)",
                                                                           "value": "WISSENSCHAFTLICH ORIENTIERTES ARBEITEN (THEMENBLOCK 1) (Pflegetherapeut Wunde ICW ®)"
                                                                         },
                                                                         {
                                                                           "label": "EXPERTENSTANDARD (THEMENBLOCK 2) (Pflegetherapeut Wunde ICW ®)",
                                                                           "value": "EXPERTENSTANDARD (THEMENBLOCK 2) (Pflegetherapeut Wunde ICW ®)"
                                                                         },
                                                                         {
                                                                           "label": "LEBENSQUALITÄT, SELBSTPFLEGEMANAGEMENT UND EDUKATION (THEMENBLOCK 3) (Pflegetherapeut Wunde ICW ®)",
                                                                           "value": "LEBENSQUALITÄT, SELBSTPFLEGEMANAGEMENT UND EDUKATION (THEMENBLOCK 3) (Pflegetherapeut Wunde ICW ®)"
                                                                         },
                                                                         {
                                                                           "label": "CASEMANAGEMENT (THEMENBLOCK 4) (Pflegetherapeut Wunde ICW ®)",
                                                                           "value": "CASEMANAGEMENT (THEMENBLOCK 4) (Pflegetherapeut Wunde ICW ®)"
                                                                         },
                                                                         {
                                                                           "label": "PROJEKTMANAGEMENT (THEMENBLOCK 5) (Pflegetherapeut Wunde ICW ®)",
                                                                           "value": "PROJEKTMANAGEMENT (THEMENBLOCK 5) (Pflegetherapeut Wunde ICW ®)"
                                                                         },
                                                                         {
                                                                           "label": "GRUNDLAGEN DES SACHVERSTÄNDIGEN-GUTACHTENS (THEMENBLOCK 6) (Pflegetherapeut Wunde ICW ®)",
                                                                           "value": "GRUNDLAGEN DES SACHVERSTÄNDIGEN-GUTACHTENS (THEMENBLOCK 6) (Pflegetherapeut Wunde ICW ®)"
                                                                         },
                                                                         {
                                                                           "label": "PÄDAGOGISCHE AUFGABEN (THEMENBLOCK 7) (Pflegetherapeut Wunde ICW ®)",
                                                                           "value": "PÄDAGOGISCHE AUFGABEN (THEMENBLOCK 7) (Pflegetherapeut Wunde ICW ®)"
                                                                         },
                                                                         {
                                                                           "label": "LERNZIELÜBERPRÜFUNG (THEMENBLOCK 8) (Pflegetherapeut Wunde ICW ®)",
                                                                           "value": "LERNZIELÜBERPRÜFUNG (THEMENBLOCK 8) (Pflegetherapeut Wunde ICW ®)"
                                                                         }
                                                                       ]
                                          }
                                                            />
                                                        </Form.Item>
                                                      </Col> }
              </Col>

              <Col span={14}>
                  <Form.Item
                    label="Andere Fortbildungsinhalte"
                    name="AndereThemegebiete"
                  >
                    <Input placeholder="Andere Themegebiete" />
                  </Form.Item>
                </Col>

              <Divider orientation="left">Referenten</Divider>
              <Col span={22}>
                <Form.Item
                  label="Referenten auf PMP-Online"
                  name="referents"

                  rules={[
                  ]}
                >
                    <Select
                      mode="multiple"
                      allowClear
                      style={{
                        width: '100%',
                      }}
                      placeholder="Referenten auf PMP-Online"

                      options = {referentenData.map(r => ({ label: (r.Vorname + " " + r.Name), value: r.id }))}
                    />
                </Form.Item>
              </Col>
              <Col span={24}>
              <Form.List
                style={{ display: "block" }}
                className={"formList"}
                label="Externe Referenten"
                name="ExterneReferenten"
                rules={[]}
                fieldKey="ExterneReferenten"
              >
                {(fields, { add, remove }) => (
                  <div className="flexHack">
                    {fields.map((field, index) => (
                      <List.Item key={field.key}>
                        <Row style={{ flex: '0 0 100%;' }} gutter={[24, 24]}>
                          <Col span={8}>
                            <Form.Item
                                label="Name des Referenten"
                                name={[field.name, 'Name']}
                              >
                                <Input placeholder="Name" />
                            </Form.Item>
                          </Col>
                          <Col span={4}>
                              <MinusCircleOutlined onClick={() => remove(field.name)} />
                          </Col>
                        </Row>
                      </List.Item>
                    ))}
                    <Form.Item>
                      <Button
                        type="dashed"
                        onClick={() => add()}
                        style={{ width: '100%' }}
                        icon={<PlusOutlined />}
                      >
                        Externe Referenten hinzufügen
                      </Button>
                    </Form.Item>
                  </div>
                )}
              </Form.List>
                                    </Col>




                                    <Divider orientation="left">Hersteller</Divider>
                                                  <Col span={22}>
                                                    <Form.Item
                                                      label="Hersteller auf PMP-Online"
                                                      name="herstellers"

                                                      rules={[
                                                      ]}
                                                    >
                                                        <Select
                                                          mode="multiple"
                                                          allowClear
                                                          style={{
                                                            width: '100%',
                                                          }}
                                                          placeholder="Hersteller auf PMP-Online"

                                                          options = {herstellerData.map(r => ({ label: (r.Herstellername), value: r.id }))}
                                                        />
                                                    </Form.Item>
                                                  </Col>
                                                  <Col span={24}>
                                                  <Form.List
                                                    style={{ display: "block" }}
                                                    className={"formList"}
                                                    label="Externe Hersteller"
                                                    name="ExterneHersteller"
                                                    rules={[]}
                                                    fieldKey="ExterneHersteller"
                                                  >
                                                    {(fields, { add, remove }) => (
                                                      <div className="flexHack">
                                                        {fields.map((field, index) => (
                                                          <List.Item key={field.key}>
                                                            <Row style={{ flex: '0 0 100%;' }} gutter={[24, 24]}>
                                                              <Col span={8}>
                                                                <Form.Item
                                                                    label="Name des Hersteller"
                                                                    name={[field.name, 'Name']}
                                                                  >
                                                                    <Input placeholder="Name" />
                                                                </Form.Item>
                                                              </Col>
                                                              <Col span={4}>
                                                                  <MinusCircleOutlined onClick={() => remove(field.name)} />
                                                              </Col>
                                                            </Row>
                                                          </List.Item>
                                                        ))}
                                                        <Form.Item>
                                                          <Button
                                                            type="dashed"
                                                            onClick={() => add()}
                                                            style={{ width: '100%' }}
                                                            icon={<PlusOutlined />}
                                                          >
                                                            Externe Hersteller hinzufügen
                                                          </Button>
                                                        </Form.Item>
                                                      </div>
                                                    )}
                                                  </Form.List>
                                                                        </Col>
                                                                        <Divider />


            <Col span={11}>
              <Form.Item
                label="Externer Link"
                name="ExternerLink"
              >
                <Input placeholder="beispiel.de"  addonBefore="https://" />
              </Form.Item>
            </Col>

            <Col span={11}>
                          <Form.Item
                            label="Link zur Anmeldung"
                            name="Anmeldelink"
                          >
                            <Input placeholder="beispiel.de/anmeldung"  addonBefore="https://" />
                          </Form.Item>
                        </Col>
        <Divider />

            <Col span={16}>
              <Form.Item
                label={<span  style={{fontSize: '20px', fontWeight: 800}}>Profil veröffentlichen: Auf PMP online sichtbar schalten</span>}
                name="Published"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
            </Col>
            { selectedSubTitle === "Veranstalter: Premium" && <Col span={16}>
              <Form.Item
                label={<span  style={{fontSize: '20px', fontWeight: 400}}>Fokussiere Profil</span>}
                name="Fokusiere"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
            </Col> }
            </Row>
            <Button
              className="veranstaltung_save_btn"
              htmlType="submit"
              type="primary"
              size="large"
            >
              {loading ? (
                <>
                  <Spin size="small" /> Speichern...
                </>
              ) : (
                "Speichern"
              )}
            </Button>
          </Form>
        </Card>
    </> : <div style={{ textAlign: 'center', padding: '20px' }}><FrownOutlined style={{ fontSize: '32px', color: '#3545b3' }} /><br />Sie haben bereits Ihr Limit an Veranstaltungen erreicht, es können keine weiteren erstellen werden.</div> } </>
  );
};

export default VeranstaltungProfile;